<template>
	<div id="programBox" class="statv_wrapper">
		<h3 class="disabled"> PROGRAM </h3>
		<div class="pro_header" v-show="programs.length > 0">
			<p class="title"> 
				<span> WHAT'S NEW </span> 
			</p>
		</div>
		<template>
			<div class="program-slider" v-if="programs.length > 0">
				<slick class="pro_contents" :options="slickOption">
					<figure class="pro_item" v-for="(program, idx) in programs" :key="`program_${idx}`"  >
						<!-- <div class="pro_thumnail" :style="{'backgroundImage': `url(${program.img_program_url})`}"></div> -->
						<div class="pro_thumnail_box">
							<img class="pro_thumnail" :src="`${program.img_program_url}`" :alt="program.title"/>
						</div>
						<p class="pro_title"> {{program.title}} </p>
					</figure>
				</slick>
			</div>
		</template>
	</div>
</template>
<script>
import * as Store from "@/store/modules/program"
export default {
	components: {
		Slick: () => import('vue-slick')
	},
  data() {
    return {
			slickOption: {
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				speed: 600,
				centerMode: false,
				variableWidth: true,
				swipe: true,
				autoplay: false,
				arrows: true,
				draggable: false,
				loop: true,
				prevArrow: '<button class="slick-arrow slick-prev"></button>',
				nextArrow: '<button class="slick-arrow slick-next"></button>',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							centerMode: true,
						}
					}
				]
			}
    }
  },
  computed: {
    ...Store.mapState([
      'programs'
    ])
  },
  async created() {
    await this.getPrograms()
  },
  methods: {
    ...Store.mapActions([
      'getPrograms'
    ]),
  }
}
</script>
<style lang="less">
#programBox {
	.pro_header {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		letter-spacing: 0;
		margin-bottom: 5px;
		color: #ff0043;
		.title {
			font-size: 36px;
			font-family: "BebasNeue";
		}
	}
	.program-slider {
		position: relative;

		.slick-arrow {
			position: absolute;
      width: 12px;
			height: 88%;
      margin: auto;
      top: 0;
      bottom: 0;
      border: none;
      cursor: pointer;
      vertical-align: middle;
			margin-bottom: 45px;
			background-color:rgba(0, 0, 0, 0);
			background-repeat: no-repeat;
			background-position: center;

			&.slick-prev {
        background-size: 12px;
				background-image: url("~@/assets/image/schedule/arrow_left.png");
				left: -30px;
			}

			&.slick-next {
        background-size: 12px;
				background-image: url("~@/assets/image/schedule/arrow_right.png");
				right: -30px;
			}
		}

		.pro_contents {
			display: flex;
			flex-flow: row wrap;
			justify-content: center;
			align-items: center;
			position: relative;

			.slick-list {
				.slick-track {
					.slick-slide {
						margin-right: 36px;
						&:focus { outline: none; }
					}
				}
			}

			.pro_item {
				color: #8F8F8F;

				.pro_thumnail_box {
					width: 243px;
					height: 342px;
					overflow: hidden;
					margin-bottom: 24px;
					.pro_thumnail {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
				.pro_title {
					font-size: 18px;
					font-weight: bold;
					transform: skew(-0.05deg);
					text-align: center;
				}
			}
		}
	}
}

.m #programBox {
	width: 100%;
	.pro_header {
		margin-bottom: 15px;
		padding-left: 30px;
		.title {
			font-size: 50px;
		}
	}
	.pro_contents {
		.slick-list {
			.slick-track {
        .slick-slide {
          opacity: 0.5;
					margin-right: 30px;
        }
				.slick-slide.slick-current {
					opacity: 1;
				}
      }
		}
		.pro_item {
			flex-basis: calc(50% - 15px);

			.pro_thumnail_box {
				width: 337px;
				height: 477px;
			}
			.pro_thumnail {
				width: 100%;
				margin-bottom: 17px;
			}
			.pro_title {
				font-size: 25px;
			}
		}
	}
}

</style>
